import { ArrowForwardIcon } from '@chakra-ui/icons'
import { Flex, HStack, Text } from '@chakra-ui/react'
import { colors } from '@hb/shared'

import { useFirebase } from '@chem-po/firebase-web'
import { useAuth } from '@hb/react'
import React, { useCallback, useEffect, useState } from 'react'
import { signOut } from '../../backend/auth/signIn'
import { useNavigate } from '../../hooks/navigation'
import { ActionButton } from '../Buttons/ActionButton'
import { DefaultModal } from '../Modals/DefaultModal'
import { SignInContent } from './SignInContent'

export const UserPanel: React.FC<{ noSignOut?: boolean }> = ({ noSignOut }) => {
  const { user, authUser } = useAuth()
  const { auth } = useFirebase()
  const navigate = useNavigate()
  const handleSignOut = useCallback(async () => {
    navigate('/')
    await signOut(auth)
  }, [navigate, auth])

  const [modalIsOpen, setModalIsOpen] = useState(false)

  useEffect(() => {
    if (authUser?.emailVerified) {
      setModalIsOpen(false)
    }
  }, [authUser])

  return (
    <Flex w="100%" direction="column" borderBottomRadius={4}>
      {noSignOut ? null : (
        <Flex
          borderTop={authUser ? '1px solid' : '0px solid'}
          borderColor="gray.200"
          transition="all 300ms"
          w="100%"
          bg={authUser ? 'gray.100' : 'transparent'}
          _dark={{ bg: authUser ? 'gray.900' : 'transparent', borderColor: 'gray.700' }}>
          <ActionButton
            border="none"
            w="100%"
            boxShadow="none"
            justifyContent="center"
            id="sign-in-button"
            onClick={
              !user
                ? () => {
                    setModalIsOpen(true)
                  }
                : handleSignOut
            }
            borderRadius={4}
            background={colors.green.hex}
            py={2}
            _hover={{ background: 'green.300' }}
            _dark={{
              background: colors.green.hex,
              _hover: { background: 'green.600' },
            }}
            size="none"
            color="white"
            fontSize="sm"
            height={authUser ? '30px' : '50px'}
            mt={0}>
            <HStack filter="drop-shadow(1px 1px 4px #00000066)">
              <Text>{authUser ? 'Sign out' : 'Sign in / Register'}</Text>
              {authUser ? <ArrowForwardIcon /> : null}
            </HStack>
          </ActionButton>
        </Flex>
      )}
      <DefaultModal
        overlayHeader
        isOpen={modalIsOpen}
        closeOnOverlayClick={false}
        onClose={() => {
          setModalIsOpen(false)
        }}
        closeOnEsc={false}
        render={() => (
          <SignInContent
            onClose={() => {
              setModalIsOpen(false)
            }}
          />
        )}
      />
    </Flex>
    // </Container>
  )
}
